var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g({attrs:{"type":"tel","label":_vm.label,"error-messages":_vm.errorMessages,"solo":_vm.solo},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }